import { env } from "./env";
import { Sans } from "./sdk";

export interface PdfServiceResponse {
  url: string;
  expiresIn: number;
}

export interface NotesPdfExportStartResponse {
  requestId: string;
  status: "in_progress" | "complete" | "error";
}

export interface NotesPdfExportStatusResponse {
  requestId: string;
  status: "in_progress" | "complete" | "error";
  url?: string;
  expiresIn?: number;
  message?: string;
}

const getPdfServiceBaseUrl = () => {
  const baseUrl = env.VITE_API_URI;
  if (!baseUrl) {
    throw new Error("VITE_API_URI is not set");
  }

  let normalizedBaseUrl = baseUrl;
  while (normalizedBaseUrl.endsWith("/")) {
    normalizedBaseUrl = normalizedBaseUrl.slice(0, -1);
  }

  return normalizedBaseUrl;
};

const requestPdfService = async <T>(path: string, init?: RequestInit): Promise<T> => {
  const { id } = await Sans.sdk.core.api.tokens.freshTokens();
  const response = await fetch(`${getPdfServiceBaseUrl()}${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      "X-ACCESS-TOKEN": id ? `Bearer ${id}` : "",
      ...init?.headers,
    },
  });

  if (!response.ok) {
    const errorBody = await response.text();
    throw new Error(errorBody || `pdf-service request failed with ${response.status}`);
  }

  return (await response.json()) as T;
};

export const startNotesPdfExport = (trainingId: number) =>
  requestPdfService<NotesPdfExportStartResponse>("/pdf/notes_download_generate", {
    method: "POST",
    body: JSON.stringify({ trainingId }),
  });

export const getNotesPdfExportStatus = (requestId: string) =>
  requestPdfService<NotesPdfExportStatusResponse>(`/pdf/notes_download_status/${requestId}`);

export const downloadCertificate = (trainingId: number, instanceId: string) =>
  requestPdfService<PdfServiceResponse>(`/pdf/certificate_download/${trainingId}/${instanceId}`);
